import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Payment } from 'anchor-shared/lib/model/entity/payment';
import { VesselRateCalculationService } from '../../../../../core/services/vessel-rate-calculation-service';

@Component({
  selector: 'app-refund-payment-dialog',
  templateUrl: './refund-payment-dialog.component.html',
  styleUrls: ['./refund-payment-dialog.component.scss'],
})
export class RefundPaymentDialogComponent {
  modalTitle: string;
  descriptionTitle: string;
  showDescription: boolean;
  refundButtonText: string;
  payment: Payment;
  refundDetails: { key: string; value: string; onClick?: () => void }[];
  expanded = true;
  inputs = {
    amount: null,
    description: null,
  };
  error;

  constructor(
    private dialogRef: MatDialogRef<RefundPaymentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public vesselRateCalcService: VesselRateCalculationService,
  ) {
    const {
      payment,
      refundAmount,
      options: {
        modalTitle = 'Refund Payment',
        descriptionTitle = 'Description',
        showDescription = false,
        refundDetails = [],
        refundButtonText = 'Refund',
      },
    } = this.data;
    this.payment = payment;
    this.inputs.amount = Number(refundAmount || payment.amount).toFixed(2);
    this.refundDetails = refundDetails;
    // options
    this.modalTitle = modalTitle;
    this.descriptionTitle = descriptionTitle;
    this.showDescription = showDescription;
    this.refundButtonText = refundButtonText;
  }

  submit() {
    const { valid, error } = this.data.validator(this.inputs);
    if (valid) {
      this.data.onSubmit(this.inputs);
      this.closeDialog(true);
    } else if (error) {
      this.error = error;
    }
  }

  closeDialog(refundSuccessful: boolean) {
    this.dialogRef.close(refundSuccessful);
  }
}
